import React, { ReactNode } from 'react';

import { cx } from '@travel/utils';

import styles from './title.module.scss';

type Props = {
  className?: string;
  title: ReactNode;
  onClick?: () => void;
};

const Title = (props: Props) => {
  const { title, className, onClick } = props;
  return (
    <h5 className={cx(styles.title, className)} onClick={onClick} data-testid="component-title">
      {title}
    </h5>
  );
};

export default Title;
